import { memo, useMemo } from 'react';

import Draw from '@apps/draw/Draw';
import { DrawOptionsProvider, DrawProvider } from '@apps/draw/store';
import type { DrawOptions } from '@apps/draw/store/types';
import { useDrawCentreOptions } from '@apps/draw-centre/store';

const DrawResults = () => {
  const { options } = useDrawCentreOptions();
  const drawOptions = useMemo<DrawOptions>(() => ({ ...options, isPotsTab: false }), [options]);
  return (
    <DrawOptionsProvider options={drawOptions}>
      <DrawProvider>
        <Draw />
      </DrawProvider>
    </DrawOptionsProvider>
  );
};

export default memo(DrawResults);
